import { spawn } from 'redux-saga/effects';

import { watchGetPreflightCheck } from './getPreflightCheck';

export default function* saga() {
  yield spawn(watchGetPreflightCheck);
}
